var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import MUIButton from '@mui/material/Button';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function () { return ({
    root: {
        minHeight: '48px',
        fontSize: '1.1rem',
        letterSpacing: '0.01rem',
    },
}); };
var Button = forwardRef(function (props, ref) {
    var cs = useEmotionStyles(styles);
    return (React.createElement(MUIButton, __assign({ color: "primary", size: "large", variant: 'contained', fullWidth: true }, props, { className: "".concat(cs.root, " ").concat(props.className), ref: ref }), props.children));
});
Button.displayName = 'Button';
export default Button;
